import jwt from 'jwt-decode'
import * as storage from '../utils/storage'
import * as AccessTypeMode from '@scripts/AccessTypeMode';

export function UserCode() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.UserCode;
}

export function UserAssociation() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.UserAssociation;
}

export function ChatId() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.UserCode + userData.UserAssociation + userData.Company;
}

export function EmployeeId() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);
    return userData.EmployeeId == '' ? 0 : parseInt(userData.EmployeeId);
}

export function Company() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.Company;
}

export function EmployeeCode() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.EmployeeCode;
}

export function PcUserId() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return parseInt(userData.PcUserId);
}

export function PcUserDefaultId() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.PcUserDefaultId == '' ? 0 : parseInt(userData.PcUserDefaultId);
}

export function AccessType() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return parseInt(userData.AccessType);
}

export function IsEmployeeMode() {
    return AccessType() == AccessTypeMode.Employee;
}

export function IsSupervisorMode() {
    return AccessType() == AccessTypeMode.Supervisor;
}

export function Worksite() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.Worksite;
}

export function IsCCQ() {
    const token = Token();

    if (token === null) {
        return;
    }

    const userData = jwt(token);

    return userData.IsCCQ;
}

export function SessionGuid() {
    return storage.getSessionGuid();
}

export function Token() {
    return storage.getToken();
}